import type { SVGProps } from "react";

export function IconInlineGlobe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.4">
        <path
          d="M21.7627 3.23727L17.5 7.5H15V10H23.5L27 16.5L29.8103 13.6897M21.7627 3.23727C20.0052 2.44245 18.0543 2 16 2C12.573 2 9.43353 3.23136 7 5.27577M21.7627 3.23727C25.9469 5.12952 29.0347 9.01894 29.8103 13.6897M29.8103 13.6897C29.9351 14.4413 30 15.2131 30 16C30 23.732 23.732 30 16 30C14.0475 30 12.1884 29.6003 10.5 28.8783M10.5 28.8783V25.5L7 22H3.34726M10.5 28.8783C7.35892 27.5351 4.80865 25.0763 3.34726 22M3.34726 22C2.48338 20.1815 2 18.1472 2 16C2 15.321 2.04834 14.6532 2.14178 14M2.14178 14H7V5.27577M2.14178 14C2.64069 10.512 4.42524 7.43883 7 5.27577M24 17L20.5 24H17.5V19H14V13H22L24 17Z"
          stroke="#5486FA"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
